import type { Box } from '@mui/material';
import type { ComponentProps } from 'react';
import type { DevelopmentType } from '@/types/GraphqlSchema';
import { useDevelopmentType } from '../../../hooks/useDevelopmentType';
import { ChecklistFilter } from '../ChecklistFilter';

type DevelopmentTypeFilterProps = {
  value: DevelopmentType[];
  onChange: (types: DevelopmentType[]) => void;
} & Omit<ComponentProps<typeof Box>, 'onChange' | 'value'>;

const DevelopmentTypeFilter = ({ value, onChange, ...props }: DevelopmentTypeFilterProps) => {
  const { developmentTypes, loading } = useDevelopmentType({
    fetchPolicy: 'cache-and-network',
  });

  return (
    <ChecklistFilter<DevelopmentType>
      {...props}
      value={value}
      options={developmentTypes}
      onChange={onChange}
      label='Development Type'
      loading={loading}
      dataId='development-type-filter'
    />
  );
};

export { DevelopmentTypeFilter };
